<template>
  <div class="home">
    <div class="container-fluid" style="min-height: 100vh;">
      <div class="container">
        <div class="row">
          <div class="col-sm-3">

          </div>
          <div class="col-sm-6">
            <div class="row" style="margin-top: 25%; margin-bottom: 30px;">
              <div class="col-sm-12">
                <div align="center">
                  <router-link to="/jobs"><img alt="Logo" src="../assets/images/logo.jpg" width="50%" /></router-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="bascoLoginContainer">
                  <form @submit.prevent="login">
                  <div class="row">
                    <div class="col-sm-12">
                      <input type="text" v-model="auth.email" class="form-control" id="email" placeholder="Email" autocomplete="username" required />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <input type="password" v-model="auth.password" class="form-control" id="password" placeholder="Password" autocomplete="current-password" required />
                    </div>
                  </div>
                  <div class="row" v-if="error">
                    <div class="col-sm-12">
                      <p class="text-danger">{{ error }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <button type="submit" :disabled="processing">
                        {{ processing ? 'Logging in...' : 'Login' }}
                      </button>
                    </div>
                  </div>
                  </form>
                  <div class="row">
                    <div class="col-sm-12">
                      <div align="right">
                        <!--<router-link to="/jobs" class="bascoLink">Forgot your password?</router-link>-->
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 30px; margin-bottom: 50px;">
                    <div class="col-sm-1">
                    </div>
                    <div class="col-sm-10">
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">

          </div>
        </div>
      </div>
    </div>
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  </div>
</template>

<script>
import axios from 'axios'
import '@/assets/css/login.css'
import { setSession } from '@/auth'
export default {
  name: 'login',
  data () {
    return {
      auth: {
        email: '',
        password: ''
      },
      processing: false,
      error: ''
    }
  },
  methods: {
    async login () {
      if (this.processing) return

      this.processing = true
      this.error = ''

      try {
        const { data } = await axios.post('/api/login', this.auth)
        setSession(data.data.token, data.data.user)

        const redirect = this.$route.query.redirect
        this.$router.push(redirect && redirect.startsWith('/') ? redirect : { name: 'Orders' })
      } catch (err) {
        const res = err.response
        if (res && res.status === 429) {
          this.error = 'Too many attempts. Please wait a minute and try again.'
        } else if (res && res.data && res.data.message) {
          this.error = res.data.message
        } else {
          this.error = 'Could not reach the server. Check your connection and try again.'
        }
      } finally {
        this.processing = false
      }
    }
  }
}
</script>
